export class AccountModel {
    // public Id :number = 0;
    public Name: string = "";
    public Company: string = "";
    public EmailAddress: string = "";
    public IsActive: boolean = false;
    public IsDeleted: boolean = false;
    public CreatedDate: string = "";
    public LastUpdatedDate: string = "";

    public ContactName: string = "";
    public ContactNumber: string = "";
    public CompanyType: number = 0;

    public UserCounter: number = 0;
    public ObjectCounter: number = 0;
    public DepartmentCounter: number = 0;
    public EnablePopupMobileMessage: boolean = false;
    public PopupMobileMessage: string = "";
    public PopupMobileMessageLogout: string = "";
}



// WEBPACK FOOTER //
// ./src/app/models/AccountModel.ts